import { Component, Input, OnInit, SimpleChanges } from '@angular/core';
import { forkJoin } from 'rxjs';
import { VhEventMediator, VhQueryAutoWeb } from 'vhautowebdb';
import { HttpClient } from '@angular/common/http';
import { isPlatformBrowser } from '@angular/common';
import { PLATFORM_ID, Inject, Injectable } from '@angular/core';
import { AtwUpdateDbComponent } from 'vhobjects-service';
import { FunctionService  } from 'vhobjects-service';

@Component({
  selector: 'atw-profile-user-admin-config',
  templateUrl: './profile-user-admin-config.component.html',
  styleUrls: ['./profile-user-admin-config.component.scss']
})
export class AtwProfileUserAdminConfig extends AtwUpdateDbComponent  implements OnInit {

  @Input() objectChoosing: any; // lấy giá trị data trả vể từ page
  @Input() device: any; // xác định device là desktop hay mobile
  @Input() class: any; // là dữ liệu desktop_class hoặc mobile_portrait_class từ database
  @Input() config: any;
  @Input() type: any; // là dữ liệu desktop_config hoặc mobile_config từ database
  @Input() staticdata: any; // là dữ liệu staticdata từ database

  isViewAll: boolean = false; // biến flag để hiện thị phần mở rộng cấu hình
  currentViewAll: any = {};
  isCollapsed: boolean = false;
  styles_field = [
    {
      title: 'hieu_ung_khi_chon',
      index: 1,
    },
    {
      title: 'hieu_ung_khi_cham',
      index: 2,
    },
    {
      title: 'dieu_chinh_vien',
      index: 3,
    }
  ];

  dataAfterChange: any = {} // lưu tên và style data để cập nhật vào database.
  valueRange: number = 0; // biến này tính giá trị của (input range / 100) để tính độ trong suốt
  valueParameter: number = 0; // biến này tính giá trị của (input range) để hiện thị giá trị ra màn hình
  isOpenBackground: boolean = false; // biến này dùng để mở bảng màu
  fieldSettingEffect: string = '';
  isOpenOptionsBorder: boolean = false; // biến này dùng để mở bảng lựa chọn viền của menu
  isOpenOptionsSubBorder: boolean = false; // biến này dùng để mở bảng lựa chọn viền của sub-menu
  isOpenOptionsBorderSymbol: boolean = false; // biến này dùng để mở bảng lựa chọn viền của biểu tượng
  isActiveShowSubItem: boolean = false; // biến này xác định mở hay đóng giao diện sub-menu để dễ config
  style_color: string = '' // biến này lấy giá trị của màu rgb và alpha;
  arr_link_page: any;
  configMode: 'basic' | 'advanced' = 'basic';

  optionsIcon = [
    { value: 'keyboard_arrow_down', label: 'keyboard_arrow_down', icon: 'keyboard_arrow_down' },
    { value: 'keyboard_arrow_right', label: 'keyboard_arrow_right', icon: 'keyboard_arrow_right' },
    { value: 'arrow_drop_down', label: 'arrow_drop_down', icon: 'arrow_drop_down' },
    { value: 'arrow_right', label: 'arrow_right', icon: 'arrow_right' },
    { value: 'chevron_right', label: 'chevron_right', icon: 'chevron_right' },
    { value: 'expand_more', label: 'expand_more', icon: 'expand_more' },
  ];
  fonts = [];
  backgroundColor: any = [];


  radius: string;
  subWidth: string;
  subHeight: string;
  subLetterSpacing: string;
  subMargin: string;
  subWidhtBorder: string;
  subMenuItemRadius: string;
  menuList: any = [
    {
      name: 'thong_tin',
      key: 'user_info'
    },
    {
      name: 'doi_mat_khau',
      key: 'user_password'
    },
    {
      name: 'don_mua',
      key: 'user_purchase'
    },
    {
      name: 'hang_thanh_vien',
      key: 'user_rank'
    },
    {
      name: 'phieu_mua_hang',
      key: 'user_coupon'
    },
    {
      name: 'chuong_trinh_ban_hang_voucher',
      key: 'tab_all'
    },
    {
      name: 'dat_mua_voucher',
      key: 'tab_buy'
    },
    {
      name: 'voucher_cua_toi',
      key: 'tab_my_voucher'
    },
    {
      name: 'doi_voucher_lay_hang',
      key: 'tab_change'
    },
    {
      name: 'hoa_don_voucher',
      key: 'tab_receipt'
    },
    {
      name: 'chuong_trinh_ban_hang_the_tra_truoc',
      key: 'tab_card_all'
    },
    {
      name: 'dat_mua_the_tra_truoc',
      key: 'tab_card_buy'
    },
    {
      name: 'the_tra_truoc_cua_toi',
      key: 'tab_card_my_payment'
    },
    {
      name: 'doi_the_tra_truoc_lay_hang',
      key: 'tab_card_change'
    },
    {
      name: 'hoa_don_the_tra_truoc',
      key: 'tab_card_receipt'
    },
    {
      name: 'dang_xuat',
      key: 'user_signout'
    },
  ];

  constructor(
    public vhQueryAutoWeb: VhQueryAutoWeb,
    private http: HttpClient,
    public vhEventMediator: VhEventMediator,
    @Inject(PLATFORM_ID) private platformId: Object,
        public functionService: FunctionService
  ) {
    super(vhQueryAutoWeb, vhEventMediator, functionService);
  }

  ngOnInit(): void {



    forkJoin([
      this.http.get('assets/background-colors/background-colors.json'),
      this.http.get('assets/fonts/fonts.json')
    ]).subscribe(([background_colors, fonts]: any) => {
      this.fonts = fonts;
      this.backgroundColor = background_colors;
    })



    this.updateObject();
  }



  /** 
   * Handle remove menu trên mobile-menu
   * @param tree: Biến dùng để lưu data menu
   * @param currentLevel: Hàm trả về level cao nhất của cây
   * 
   */
  getMaxLevel(tree, currentLevel = 1) {
    if (!tree || !tree.length) return currentLevel;

    let maxLevel = currentLevel;

    for (let node of tree) {
      if (node.children && node.children.length > 0) {
        const level = this.getMaxLevel(node.children, currentLevel + 1);
        if (level > maxLevel) {
          maxLevel = level;
        }
      }
    }

    return maxLevel;
  }

  /**
   * Hàm này dùng để dịch chuyển mobilemenu con về bên phải trên mobile khi click về menu cha 
   * @param menuId:cấp của menu con.
   */
  addAttrClass(menuId: number) {
    if (menuId !== 0) {
      this.class[`mobilemenu__list--item${menuId}`]['padding-left'] = (menuId + 1) * 10 + 'px'
    }
  }



  /**
   * Chuyển đổi mã màu hexadecimal thành mã màu rgba.
   * @param hex : tham số trả về mã màu hex
   * @returns string : trả về chuỗi rgb
   */
  hexToRGB(hex: string): string {
    // Loại bỏ ký tự '#' từ mã hex
    hex = hex.replace('#', '');

    // Tách mã hex thành các thành phần màu
    const r = parseInt(hex.substring(0, 2), 16);
    const g = parseInt(hex.substring(2, 4), 16);
    const b = parseInt(hex.substring(4, 6), 16);

    // Trả về giá trị RGB
    return `${r}, ${g}, ${b}`;
  }
  /**
   * Xử lý lấy thông số giá trị background color.
   * @param event : trả về giá trị từ 0-100
   */
  getValueRangeBackgroundColor(e, type, id?: number) {
    // lấy giá trị tham số event của thanh slide khi thay đổi.
    this.valueParameter = e.target.value;
    // Tính giá trị alpha cho màu rgb.
    const data = (this.device == 'desktop') ? this.class[`${type}__item`] : this.class[`${type}__list--item${id}`];
    const lastCommaIndex = data['background-color'].lastIndexOf(',');
    const prefix = data['background-color'].substring(0, lastCommaIndex + 1);
    this.style_color = `${prefix} ${this.valueParameter / 100})`;

    data['background-color'] = this.style_color;
    this.updateObject();
  }
  /**
   * Hàm này lấy giá trị màu nền của input color
   * @param event : trả về màu được chọn từ input color
   */
  updateColorInput(e, type, mobileid?: number) {
    const value_color = e.target.value;
    const data_desktop = this.class[`${type}__item`];
    const data_mobile = this.class[`${type}__list--item${mobileid}`]
    // Chuyển đổi chuổi màu hexadecimal thành rgb
    // Nối chuỗi rgb + giá trị alpha và cập nhật lưu vào database.
    if (this.device == 'desktop') {
      this.style_color = `rgba(${this.hexToRGB(value_color)}, ${this.config[`${type}_background-color`]['value_range']
        })`;
      data_desktop.background = this.style_color;
      this.updateObject();
    } else {
      this.style_color = `rgba(${this.hexToRGB(value_color)}, ${this.config[`background-color`]['value_range']
        })`;
      data_mobile.background = this.style_color;
      this.updateObject();
    }

  }
  /**
   * Hàm này dùng để click chọn màu nền của danh sách màu. 
   * @param bgColor : trả về màu được chọn
   * @param event : trả về element được active
   */
  chooseBg(bgColor, event, type, mobileid?: number | null) {

    if (isPlatformBrowser(this.platformId)) {
      // Set style hightlight cho element có class active để biết options direction nào đang được chọn.
      // Lấy ra element màu được click từ tham số event trả về.
      var activeGradient = document.querySelector('.container-color .active') as HTMLElement;
      if (activeGradient) activeGradient.classList.remove('active');
      event.currentTarget.classList.add('active');

      const data = this.device == 'desktop' ? this.class[`${type}__item`] : this.class[`${type}__list--item${mobileid}`]
      // Lấy giá trị màu được click từ tham số bgColor.
      //  Chuyển đổi màu được click thành mã rgb , thêm alpha vào mã rgb và lưu vào database.
      // 
      data['background-color'] = `rgba(${this.hexToRGB(bgColor.bgColor)}, ${(this.device == 'desktop') ? this.config[`${type}_background-color`].value_range : this.config[`background-color`].value_range})`;
      this.updateObject()
    }
  }



  /**
   * Hàm update object vào database.
   */
  updateObject() {
    this.vhQueryAutoWeb.updateObject(this.objectChoosing._id, { [this.device + '_class']: this.class, [this.device + '_config']: this.config, staticdata: this.staticdata })
      .then((bool: any) => {

      })
  }

  /**
   * Hàm update class vào database.
   */
  updateClass() {
    this.vhQueryAutoWeb.updateObject(this.objectChoosing._id, { [this.device + '_class']: this.class })
      .then((bool: any) => {

      })
  }

  /**
   * Hàm update config vào database.
   */
  updateConfig() {
    this.vhQueryAutoWeb.updateObject(this.objectChoosing._id, { [this.device + '_config']: this.config })
      .then((bool: any) => {

      })
  }

  /**
   * Update trường mobile_portrait_hidden or desktop_hidden cho object
   * @param value
   */
  updateHidden(value) {

    this.vhQueryAutoWeb.updateObject(this.objectChoosing._id, value).then(
      (bool) => {

      },
      (error) => {
        console.error(error);
      }
    );
  }

  /**
   * Cập nhật staticdata vào database.
   */
  updateStaticData() {
    this.vhQueryAutoWeb.updateObject(this.objectChoosing._id, { staticdata: this.staticdata })
      .then((bool) => {



      });


  }


  /**
   * Hàm này dùng để mở rộng phần cấu hình.
   * @param field_text : trả về phần tử được chọn của mảng style_field
   */
  openViewAll(field_text) {
    this.currentViewAll = field_text;
    this.isViewAll = !this.isViewAll;
  }

  /**
   * Hàm này dùng để cho phép mở menu config .
   * Khi mở ở vị trí menu[0] thì các menu khác (menu[n]) đóng lại.
   * @param: value
   */
  openHandler(value: string): void {
    for (const key in this.openMap) {
      if (key !== value) {
        this.openMap[key] = false;
      }
    }
  }
  openMap: { [name: string]: boolean } = {
    menu1: true,
    menu2: false,
    menu3: false,
    menu4: false,
    menu5: false,
    menu6: false,
    menu7: false,
    menu8: false,
    menu9: false,
    menu10: false,
    menu11: false,
    menu12: false
  };

}
